import CommonModal from "components/modal-box/CommonModal";
import React, { useLayoutEffect, useState } from "react";
import "./WelcomePopup.scss";
import { errorResponse, failResponse } from "config/config";
import { getAdvertisementData } from "services/home";
import { useNavigate } from "react-router-dom";

const WelcomePopup = () => {
  const navigate = useNavigate();
  const [popup, setPopup] = useState(false);
  const [advertisementData, setAdvertisementData] = useState([]);

  const getAdvertisement = async () => {
    try {
      const res = await getAdvertisementData();

      if (res.code === 200) {
        // sirf wahi items lo jinke paas image hai, max 2
        const list = Array.isArray(res.data)
          ? res.data.filter((item) => item && item.image).slice(0, 2)
          : [];

        setAdvertisementData(list);

        // FIX: poster hai tabhi popup khulega, warna kabhi nahi
        setPopup(list.length > 0);
      } else {
        setPopup(false);
        failResponse(res);
      }
    } catch (err) {
      setPopup(false);
      errorResponse(err);
    }
  };

  const handleclick = (link) => {
    if (link) {
      window.open(link, "_blank");
      setPopup(false);
    } else {
      console.error("Advertisement link is missing or invalid.");
    }
  };

  // agar image load na ho to us poster ko hata do
  const handleImageError = (index) => {
    setAdvertisementData((prev) => {
      const next = prev.filter((_, i) => i !== index);
      if (next.length === 0) setPopup(false);
      return next;
    });
  };

  React.useEffect(() => {
    getAdvertisement();
    // eslint-disable-next-line
  }, []);

  useLayoutEffect(() => {
    const pathName = window.location.pathname;

    if (pathName !== "/") {
      setPopup(false);
    }
  }, [popup]);

  // FIX: data nahi hai to modal render hi mat karo (black screen nahi aayegi)
  if (!popup || advertisementData.length === 0) {
    return null;
  }

  return (
    <>
      <CommonModal
        className="welcome_wrapper"
        show={popup}
        handleClose={() => setPopup(false)}
        size="lg"
      >
        <div className="welcome" style={{ cursor: "pointer" }}>
          {/* --- ONE IMAGE --- */}
          {advertisementData.length === 1 && (
            <div
              className="image_wrap"
              style={{ height: "100%" }}
              onClick={() => handleclick(advertisementData[0].link)}
            >
              <img
                src={advertisementData[0].image}
                alt="Welcome"
                className="img"
                onError={() => handleImageError(0)}
              />
            </div>
          )}

          {/* --- TWO IMAGES SIDE BY SIDE --- */}
          {advertisementData.length === 2 && (
            <div className="double_image_wrapper">
              <div
                className="image_box left"
                onClick={() => handleclick(advertisementData[0].link)}
              >
                <img
                  src={advertisementData[0].image}
                  alt="Ad1"
                  className="img"
                  onError={() => handleImageError(0)}
                />
              </div>

              <div
                className="image_box right"
                onClick={() => handleclick(advertisementData[1].link)}
              >
                <img
                  src={advertisementData[1].image}
                  alt="Ad2"
                  className="img"
                  onError={() => handleImageError(1)}
                />
              </div>
            </div>
          )}
        </div>
      </CommonModal>
    </>
  );
};

export default WelcomePopup;